import React from 'react';
import { formatCookingIngredientQuantityParts } from '../utils/unitConversion';

export interface CookingQuantityLabelProps {
    quantity: number;
    unit: string;
    t: (k: string) => string;
    rtl?: boolean;
    isMeat?: boolean;
    struck?: boolean;
    hideUnit?: boolean;
    variant?: 'default' | 'inline';
}

/** Shared quantity + unit text used in view mode and edit-mode capsule triggers. */
const CookingQuantityLabel: React.FC<CookingQuantityLabelProps> = ({
    quantity,
    unit,
    t,
    rtl = false,
    isMeat = false,
    struck = false,
    hideUnit = false,
    variant = 'default',
}) => {
    const parts = formatCookingIngredientQuantityParts(quantity, unit, t);

    const amountClassName = variant === 'inline'
        ? `font-mono tabular-nums whitespace-nowrap ${struck ? 'line-through text-slate-300 dark:text-slate-600 opacity-60' : ''}`
        : `font-mono text-sm font-bold tabular-nums whitespace-nowrap ${struck
            ? 'line-through text-slate-300 dark:text-slate-600'
            : isMeat
                ? 'text-rose-700 dark:text-rose-400'
                : 'text-slate-600 dark:text-slate-300'}`;

    const unitClassName = struck
        ? 'line-through text-slate-300 dark:text-slate-600'
        : '';

    if (!parts.amount) {
        return <span className={unitClassName}>{parts.unit}</span>;
    }

    if (hideUnit) {
        return (
            <bdi dir="ltr" className={amountClassName}>
                {parts.amount}
            </bdi>
        );
    }

    if (rtl) {
        return (
            <>
                <bdi dir="ltr" className={amountClassName}>
                    {parts.amount}
                </bdi>
                {'\u00A0'}
                <span className={unitClassName}>{parts.unit}</span>
            </>
        );
    }

    return (
        <>
            <span className={amountClassName}>{parts.amount}</span>
            {'\u00A0'}
            <span className={unitClassName}>{parts.unit}</span>
        </>
    );
};

export default CookingQuantityLabel;
